import { Card as CCard } from '@consta/uikit/Card';
import styles from './styles.module.css';

export const Card: React.FC<Props> = ({ children, className = '', ...props }) => (
  <CCard className={`${styles.card} ${className}`} {...props}>
    {children}
  </CCard>
);

type Props = React.ComponentProps<typeof CCard> & {
  children: React.ReactNode | React.ReactNode[];
};
